@if (emptyList()) {
  <ng-container *ngTemplateOutlet="empty" />
} @else {
  <!-- TODO: Voir si on utilise la sélection et où on l'affiche.
  <header>
    @if (!checkboxVisible()) {
      <button class="selectedAllBtn" (click)="checkboxVisible.set(true)">
        {{ 'contents_list.select' | translate }}
      </button>
    } @else {
      <button class="selectedAllBtn">
        <input
          [ngClass]="{ indeterminate: selectedItemPartial() }"
          [checked]="selectedAll()"
          (change)="toggleSelectAll()"
          type="checkbox"
          id="all"
          name="all"
          value="all"
        />
        <label for="all">{{ 'contents_list.select_all' | translate }}</label>
      </button>
    }
    @if (checkboxVisible()) {
      <button (click)="checkboxVisible.set(false)">{{ 'common.cancel' | translate }}</button>
      <div class="select-bottom-bar">
        <span>
          @if (selectedItemCount() === 0) {
            {{ 'contents_list.none_selected' | translate }}
          } @else {
            {{ 'contents_list.selected_count' | translate: { count: selectedItemCount() } }}
          }
        </span>

        @for (action of selectedActions(); track $index) {
          <span class="selected-action">
            <kin-icon [color]="colorService.brandSecondary400()" [name]="action" />
            <p>{{ action }}</p>
          </span>
        }
      </div>
    }
  </header>
  -->

  <app-table
    [columns]="tableColumns()"
    [datas]="tableData()"
    [actions]="actions()"
    (columnsChange)="tableColumnsService.reorderColumns($event)"
    [skeletonCount]="skeletonCount()"
    (elementChecked)="manageSeletedItemList($event)"
  />

  <app-paginator
    [isLoading]="!tableData()"
    [page]="scenicTableContentService.currentPage()"
    [totalItems]="scenicTableContentService.totalItems()"
    [itemsPerPage]="scenicTableContentService.contentLimitPerPage()"
    [firstItemInCurrentPage]="scenicTableContentService.firstItemInPage()"
    [lastItemInCurrentPage]="scenicTableContentService.lastItemInPage()"
    [lastPage]="scenicTableContentService.lastPage()"
    (nextPage)="scenicTableContentService.nextPage()"
    (goToPage)="scenicTableContentService.goToPage($event)"
    (previousPage)="scenicTableContentService.previousPage()"
    (setItemPerPage)="scenicTableContentService.setItemPerPage($event)"
  />
}

<ng-template #empty>
  <app-empty-content-list-element contentType="scenic" />
</ng-template>
